import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface CartItem {
  id: string
  skuId: number
  cakeStyleId: number
  name: string
  image: string
  price: number
  size: string
  flavor: string
  sugar?: string
  interlayer?: string
  decoration?: string
  customText?: string
  quantity: number
  isCustom: boolean
}

interface CartStore {
  items: CartItem[]
  addItem: (item: Omit<CartItem, 'id'>) => void
  removeItem: (id: string) => void
  updateQuantity: (id: string, quantity: number) => void
  clearCart: () => void
  getTotal: () => number
  getItemCount: () => number
}

export const useCartStore = create<CartStore>()(
  persist(
    (set, get) => ({
      items: [],

      addItem: (item) => {
        // 优先用 skuId 作为唯一标识（兼容旧数据用 cakeStyleId_size_flavor）
        const id = item.skuId ? `sku_${item.skuId}` : `${item.cakeStyleId}_${item.size}_${item.flavor}`
        const existingItem = get().items.find((i) => i.id === id || i.skuId === item.skuId)

        if (existingItem) {
          set((state) => ({
            items: state.items.map((i) =>
              (i.id === id || i.skuId === item.skuId) ? { ...i, quantity: i.quantity + item.quantity } : i
            ),
          }))
        } else {
          set((state) => ({
            items: [...state.items, { ...item, id }],
          }))
        }
      },

      removeItem: (id) => {
        set((state) => ({
          items: state.items.filter((i) => i.id !== id),
        }))
      },

      updateQuantity: (id, quantity) => {
        if (quantity <= 0) {
          get().removeItem(id)
          return
        }
        set((state) => ({
          items: state.items.map((i) =>
            i.id === id ? { ...i, quantity } : i
          ),
        }))
      },

      clearCart: () => set({ items: [] }),

      getTotal: () => {
        return get().items.reduce((sum, item) => sum + item.price * item.quantity, 0)
      },

      getItemCount: () => {
        return get().items.reduce((sum, item) => sum + item.quantity, 0)
      },
    }),
    {
      name: 'cake-shop-cart',
    }
  )
)
